import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, initialized } = useAuth();
  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
